/**
 * v0.4 TD-23 (2026-09-03): 組織ノードツリーをフラット化する共通ヘルパー。
 *
 * ⚠️ 以前は**17ファイルにバイト単位で同一の実装が複製**されていた (Select の選択肢を
 * インデント付きで並べる定型処理)。全て同一だったため §8-55 型の「片方だけ更新されて
 * 機能不全になる」実害は出ていなかったが、階層の扱い (例: 停止中ノードの除外、深さ上限)
 * を変える必要が生じたときに17箇所を同期する必要があり、そのときこそ漏れが起きる。
 *
 * ノードツリーを Select 等の平坦なリストへ落とすときは必ず本ヘルパーを使うこと。
 */
import type { NodeTreeItem } from '@/stores/scope';

/** ツリーを深さ優先で平坦化し、各ノードにインデント用の深さを添えて返す。 */
export const flattenNodes = (
  nodes: NodeTreeItem[],
  depth = 0,
): Array<{ node: NodeTreeItem; depth: number }> =>
  nodes.flatMap((n) => [{ node: n, depth }, ...flattenNodes(n.children, depth + 1)]);
